import serviceHandler from "@/helpers/handlers/service";

const pending = new WeakMap();

export const hasPendingRequest = (state, key) =>
  Boolean(pending.get(state) && pending.get(state).has(key));

export function cancelRequests(state) {
  const requests = pending.get(state);
  pending.delete(state);
  if (requests) requests.forEach((controller) => controller.abort());
}

export async function loadLatest(
  { commit, state },
  key,
  operation,
  applyResponse,
  loadingKeys = [key]
) {
  let requests = pending.get(state);
  if (!requests) {
    requests = new Map();
    pending.set(state, requests);
  }
  if (requests.has(key)) requests.get(key).abort();
  const controller = new AbortController();
  requests.set(key, controller);
  const isCurrent = () =>
    pending.get(state) && pending.get(state).get(key) === controller;
  loadingKeys.forEach((name) =>
    commit("SET_LOADING", { key: name, value: true })
  );
  try {
    // Discard obsolete responses/errors before the shared error handler can display them.
    const request = Promise.resolve()
      .then(() => operation(controller.signal))
      .then(
        (response) => (isCurrent() ? response : { data: null }),
        (error) => {
          if (!isCurrent()) return { data: null };
          throw error;
        }
      );
    const response = await serviceHandler(request);
    if (isCurrent()) applyResponse(response);
  } finally {
    if (isCurrent()) {
      requests.delete(key);
      loadingKeys.forEach((name) =>
        commit("SET_LOADING", { key: name, value: false })
      );
    }
  }
}
